import type { LanguageCode } from './languages'

export const siteBaseUrl = 'https://modicafe.com'

export const siteDefaultImage = `${siteBaseUrl}/legacy-media/wp-content/uploads/2025/02/kahvaltilar-1024x768.png`
export const siteLogoImage = `${siteBaseUrl}/modi-cafe-logo.png`
export const hotelGalleryImages = [
  siteDefaultImage,
  `${siteBaseUrl}/legacy-media/wp-content/uploads/2025/02/Sicak-icecekler-1024x768.png`,
  `${siteBaseUrl}/legacy-media/wp-content/uploads/2025/02/Tatli-1024x768.png`,
]

export const seoByLanguage: Record<
  LanguageCode,
  { title: string; description: string; hotelName: string }
> = {
  tr: {
    title: 'Modi Cafe | Yalova Termal Kahvalti & Cafe',
    description:
      'Yalova Termal Modi Cafe; kahvalti, sicak kahve, tatli ve butik cafe atmosferini bir arada sunar.',
    hotelName: 'Modi Cafe',
  },
  en: {
    title: 'Modi Cafe | Breakfast & Cafe in Yalova Thermal',
    description:
      'Modi Cafe in Yalova Thermal offers breakfast, warm coffee, desserts and a boutique cafe atmosphere.',
    hotelName: 'Modi Cafe',
  },
  ru: {
    title: 'Modi Cafe | Кафе и завтраки в Ялова Термал',
    description:
      'Modi Cafe в Ялова Термал предлагает завтраки, кофе, десерты и уютную атмосферу бутикового кафе.',
    hotelName: 'Modi Cafe',
  },
}
